export default __webpack_public_path__ + "ruby.a4d2db0c.jpg";